import { FC } from 'react';
import Statistics from 'components/Statistics/Statistics';
import Sites from 'components/sites/sites';
import SiteDetail from 'components/sites/siteDetail';
import Clients from 'components/clients/clients';
import OnlineClients from 'components/clients/OnlineClients';
import UserDetails from 'components/clients/userDetails';
import Deposit from 'components/Finances/Deposit';
import WithdrawTabs from 'components/Finances/WithdrawTabs';
import Rakeback from 'components/Finances/Rakeback';
import PromoCodes from 'components/PromoCodes/PromoCodes';
import SiteSocials from 'components/SiteSocials/SiteSocials';
import AuditLogs from 'components/AuditLogs/AuditLogs';
import Payments from 'components/payments/payments';
import Login from 'components/Login/login';
import Manager from 'components/Management/manager/Manager';
import ActiveSessions from 'components/Games/ActiveSessions';
import GameStatistics from 'components/Games/GameStatistics';
import Providers from 'components/Games/Providers';
import SyncGames from 'components/Games/SyncGames';
import BlockedClients from 'components/clients/BlockedClients';

export interface RouteConfig {
  path: string;
  component: FC<any>;
  name: string;
  isPublic?: boolean;
  protected?: boolean;
  useDashboard?: boolean;
}

export const routes: RouteConfig[] = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    isPublic: true,
    protected: false,
    useDashboard: false,
  },
  {
    path: '/',
    component: Statistics,
    name: 'Statistics',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/sites',
    component: Sites,
    name: 'Sites',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/sites/:id',
    component: SiteDetail,
    name: 'Site Details',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/clients',
    component: Clients,
    name: 'Client List',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/clients/online',
    component: OnlineClients,
    name: 'Online Clients',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/clients/blocked',
    component: BlockedClients,
    name: 'Blocked Clients',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/clients/:id',
    component: UserDetails,
    name: 'User Details',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/finances/deposit',
    component: Deposit,
    name: 'Deposit',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/finances/withdraw',
    component: WithdrawTabs,
    name: 'Withdraw',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/finances/rakeback',
    component: Rakeback,
    name: 'Rakeback',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/games/sessions',
    component: ActiveSessions,
    name: 'Active session',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/games/statistics',
    component: GameStatistics,
    name: 'Game Statistics',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/games/providers',
    component: Providers,
    name: 'Providers',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/games/sync',
    component: SyncGames,
    name: 'Sync Games',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/promocodes',
    component: PromoCodes,
    name: 'Promo Codes',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/payments',
    component: Payments,
    name: 'Payments',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/management/managers',
    component: Manager,
    name: 'Managers',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/social-links',
    component: SiteSocials,
    name: 'Social Links',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/logs',
    component: AuditLogs,
    name: 'Logs',
    protected: true,
    useDashboard: true,
  },
  {
    path: '/payments',
    component: Payments,
    name: 'Payment Providers',
    protected: true,
    useDashboard: true,
  },
];
